import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {WoAsset} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-asset-list',
  templateUrl: './asset-list.component.html',
  standalone: false,
})
export class AssetListComponent implements OnInit {

  assets: WoAsset[] = [];
  isLoaded = false;

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.woService.getAssets().subscribe({
      next: (res: any) => {
        console.log('[Asset List] GET api/wo_asset', res);
        this.assets = Array.isArray(res) ? res : (res?.Data ?? res?.data ?? res ?? []);
        this.isLoaded = true;
      },
      error: () => {
        this.notification.showErrorToast('Error loading assets.');
        this.isLoaded = true;
      }
    });
  }

  edit(id: string): void {
    this.router.navigate(['/work-orders/assets/asset-form'], {queryParams: {id}});
  }

  newAsset(): void {
    this.router.navigate(['/work-orders/assets/asset-form']);
  }

  delete(id: string): void {
    this.confirmDialog.confirmThis(
      ['Delete this asset?'],
      () => {
        this.woService.deleteAsset(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Asset deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting asset.');
          }
        });
      },
      () => {
      }
    );
  }

  isOverdue(date: string | null): boolean {
    if (!date) {
      return false;
    }
    return new Date(date) < new Date();
  }

  warrantyExpiringSoon(date: string | null): boolean {
    if (!date) {
      return false;
    }
    const d = new Date(date);
    const soon = new Date();
    soon.setDate(soon.getDate() + 30);
    return d <= soon && d >= new Date();
  }
}
